import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Ourfocus(props) {
    return (
        <div className="tekrevol_ourforce p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="HR Software">
                            <h2>Business Benefits Of Integrated LMS System</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <h5 className="strong">TekRevol’s custom LMS systems and solutions help businesses achieve the
                            following benefits:</h5>
                        <p>TekRevol’s custom LMS systems and solutions help businesses achieve the following
                            benefits:</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Ourfocus;